module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_05.6f65cd5b.jpg";